import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setRegenerationReportOff, setRegenerationReportOn } from './regeneration.actions';
export const reportRegeneration = createReducer(false, on(setRegenerationReportOn, () => true), on(setRegenerationReportOff, () => false), on(resetAllCustomPdfReportItems, () => false));
